export const roomTypes = [
  {
    checked: true,
    icon: 'living.svg',
    value: 'living',
    title: {
      en: 'Living',
      ru: 'Гостиная',
    },
  },
  {
    icon: 'kitchen.svg',
    value: 'kitchen',
    title: {
      en: 'Kitchen',
      ru: 'Кухня',
    },
  },
  {
    icon: 'bathroom.svg',
    value: 'bathroom',
    title: {
      en: 'Bathroom',
      ru: 'Ванная',
    },
  },
  {
    icon: 'bedroom.svg',
    value: 'bedroom',
    title: {
      en: 'Bedroom',
      ru: 'Спальня',
    },
  },
];
